import { render, staticRenderFns } from "./collection-frame.vue?vue&type=template&id=9e9c8632&scoped=true"
import script from "./collection-frame.vue?vue&type=script&lang=js"
export * from "./collection-frame.vue?vue&type=script&lang=js"
import style0 from "./collection-frame.vue?vue&type=style&index=0&id=9e9c8632&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9c8632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e9c8632')) {
      api.createRecord('9e9c8632', component.options)
    } else {
      api.reload('9e9c8632', component.options)
    }
    module.hot.accept("./collection-frame.vue?vue&type=template&id=9e9c8632&scoped=true", function () {
      api.rerender('9e9c8632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jackpot/collection-frame.vue"
export default component.exports